import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FundriskService } from 'src/app/services/fundrisk.service';
import { Chart } from 'angular-highcharts';
@Component({
  selector: 'app-fund',
  templateUrl: './fund.component.html',
  styleUrls: ['./fund.component.scss']
})
export class FundComponent implements OnInit {
  language = JSON.parse(localStorage.getItem('language'))
  private navigateTo: any
  selectedContent: any = {}
  selectedIndex = 0
  selectedType = 'filter'
  riskLevel: string
  footerrisk: any
  flag: any
  sectionList = [
    {
      title: 'RECOMMENDED' + '\n' + 'FUND',
      icon: 'assets/images/icon/filter/icon-recommend@2x.png',
      activeIcon: 'assets/images/icon/filter/icon-recommend_@2x.png',
      content: {
        header: this.language.menutitlebar0,
        description: '',
        list: [
          {
            type: 'mm',
            riskLevel: 2,
            title: '1AM-DAILY',
            description: 'กองทุนเปิดวรรณเดลี่',
            recommended: true,
          }
        ]
      }
    },
    {
      title: this.language.menutitlebar1,
      icon: 'assets/images/icon/filter/icon-reit@2x.png',
      activeIcon: 'assets/images/icon/filter/icon-reit_@2x.png',
      content: {
        header: this.language.menutitlebar1,
        description: '',
        list: [
          {
            type: 'reit',
            riskLevel: 8,
            title: 'Test Reit',
            description: 'Reit Fund',
          },
          {
            type: 'mm',
            riskLevel: 2,
            title: '1AM-DAILY',
            description: 'กองทุนเปิดวรรณเดลี่',
            recommended: true,
          }
        ]
      }
    },
    {
      title: this.language.menutitlebar2,
      icon: 'assets/images/icon/filter/icon-mm@2x.png',
      activeIcon: 'assets/images/icon/filter/icon-mm_@2x.png',
      content: {
        header: this.language.menutitlebar2,
        // tslint:disable-next-line:max-line-length
        description: this.language.menudetailbar2,
        list: [
          {
            type: 'mm',
            riskLevel: 6,
            title: 'Test MM',
            description: 'MM Fund',
          },
        ]
      }
    },
    {
      title: this.language.menutitlebar3,
      icon: 'assets/images/icon/filter/icon-eq@2x.png',
      activeIcon: 'assets/images/icon/filter/icon-eq_@2x.png',
      content: {
        header: this.language.menutitlebar3,
        description: this.language.menudetailbar3,
        list: [
          {
            type: 'eq',
            riskLevel: 6,
            title: 'Test EQ',
            description: 'EQ Fund',
          },
          {
            type: 'eq',
            riskLevel: 6,
            title: 'Test EQ',
            description: 'EQ Fund',
          },
          {
            type: 'eq',
            riskLevel: 6,
            title: 'Test EQ',
            description: 'EQ Fund',
          },
          {
            type: 'eq',
            riskLevel: 6,
            title: 'Test EQ',
            description: 'EQ Fund',
          },
          {
            type: 'eq',
            riskLevel: 6,
            title: 'Test EQ',
            description: 'EQ Fund',
          },
        ]
      }
    },
    {
      title: this.language.menutitlebar4,
      icon: 'assets/images/icon/filter/icon-fl@2x.png',
      activeIcon: 'assets/images/icon/filter/icon-fl_@2x.png',
      content: {
        header: this.language.menutitlebar4,
        description: this.language.menudetailbar4,
        list: [
          {
            type: 'fl',
            riskLevel: 6,
            title: 'Test FL',
            description: 'FL Fund',
          },
        ]
      }
    },
    {
      title: this.language.menutitlebar5,
      icon: 'assets/images/icon/filter/icon-rof@2x.png',
      activeIcon: 'assets/images/icon/filter/icon-rof_@2x.png',
      content: {
        header: this.language.menutitlebar5,
        description: this.language.menudetailbar5,
        list: [
          {
            type: 'rof',
            riskLevel: 4,
            title: 'Test ROF',
            description: 'ROF Fund',
          },
        ]
      }
    },
    {
      title: this.language.menutitlebar6,
      icon: 'assets/images/icon/filter/icon-mf@2x.png',
      activeIcon: 'assets/images/icon/filter/icon-mf_@2x.png',
      content: {
        header: this.language.menutitlebar6,
        description: this.language.menudetailbar6,
        list: [
          {
            type: 'mf',
            riskLevel: 2,
            title: 'Test MF',
            description: 'MF Fund',
          },
        ]
      }
    },
    {
      title: this.language.menutitlebar7,
      icon: 'assets/images/icon/filter/icon-gef@2x.png',
      activeIcon: 'assets/images/icon/filter/icon-gef_@2x.png',
      content: {
        header: this.language.menutitlebar7,
        description: this.language.menudetailbar7,
        list: [
          {
            type: 'gef',
            riskLevel: 6,
            title: 'Test GEF',
            description: 'GEF Fund',
          },
        ]
      }
    },
    {
      title: this.language.menutitlebar8,
      icon: 'assets/images/icon/filter/icon-gfi@2x.png',
      activeIcon: 'assets/images/icon/filter/icon-gfi_@2x.png',
      content: {
        header: this.language.menutitlebar8,
        description: this.language.menudetailbar8,
        list: [
          {
            type: 'gfi',
            riskLevel: 6,
            title: 'Test GFI',
            description: 'GFI Fund',
          },
        ]
      }
    },
    {
      title: this.language.menutitlebar9,
      icon: 'assets/images/icon/filter/icon-gmf@2x.png',
      activeIcon: 'assets/images/icon/filter/icon-gmf_@2x.png',
      content: {
        header: this.language.menutitlebar9,
        description: this.language.menudetailbar9,
        list: [
          {
            type: 'eq',
            riskLevel: 6,
            title: 'Test EQ',
            description: 'EQ Fund',
          }
        ]
      }
    },
    {
      title: this.language.menutitlebar10,
      icon: 'assets/images/icon/filter/icon-etf@2x.png',
      activeIcon: 'assets/images/icon/filter/icon-etf_@2x.png',
      content: {
        header: this.language.menutitlebar10,
        description: this.language.menudetailbar10,
        list: [
          {
            type: 'eq',
            riskLevel: 6,
            title: 'Test EQ',
            description: 'EQ Fund',
          }
        ]
      }
    },
    {
      title: this.language.menutitlebar11,
      icon: 'assets/images/icon/filter/icon-ltf@2x.png',
      activeIcon: 'assets/images/icon/filter/icon-ltf_@2x.png',
      content: {
        header: this.language.menutitlebar11,
        description: this.language.menudetailbar11,
        list: [
          {
            type: 'eq',
            riskLevel: 6,
            title: 'Test EQ',
            description: 'EQ Fund',
          }
        ]
      }
    },
    {
      title: this.language.menutitlebar12,
      icon: 'assets/images/icon/filter/icon-rmf@2x.png',
      activeIcon: 'assets/images/icon/filter/icon-rmf_@2x.png',
      content: {
        header: this.language.menutitlebar12,
        description: this.language.menudetailbar12,
        list: [
          {
            type: 'eq',
            riskLevel: 6,
            title: 'Test EQ',
            description: 'EQ Fund',
          }
        ]
      }
    },
    {
      title: this.language.menutitlebar13,
      icon: 'assets/images/icon/filter/icon-sf@2x.png',
      activeIcon: 'assets/images/icon/filter/icon-sf_@2x.png',
      content: {
        header: this.language.menutitlebar13,
        description: this.language.menudetailbar13,
        list: [
          {
            type: 'eq',
            riskLevel: 6,
            title: 'Test EQ',
            description: 'EQ Fund',
          }
        ]
      }
    },
    {
      title: this.language.menutitlebar14,
      icon: 'assets/images/icon/filter/icon-cdf@2x.png',
      activeIcon: 'assets/images/icon/filter/icon-cdf_@2x.png',
      content: {
        header: this.language.menutitlebar14,
        description: this.language.menudetailbar14,
        list: [
          {
            type: 'eq',
            riskLevel: 6,
            title: 'Test EQ',
            description: 'EQ Fund',
          }
        ]
      }
    },
    {
      title: this.language.menutitlebar15,
      icon: 'assets/images/icon/filter/icon-cf@2x.png',
      activeIcon: 'assets/images/icon/filter/icon-cf_@2x.png',
      content: {
        header: this.language.menutitlebar15,
        description: this.language.menudetailbar15,
        list: [
          {
            type: 'eq',
            riskLevel: 6,
            title: 'Test EQ',
            description: 'EQ Fund',
          }
        ]
      }
    },
    {
      title: this.language.menutitlebar16,
      icon: 'assets/images/icon/filter/icon-pf@2x.png',
      activeIcon: 'assets/images/icon/filter/icon-pf_@2x.png',
      content: {
        header: this.language.menutitlebar16,
        description: this.language.menudetailbar16,
        list: [
          {
            type: 'eq',
            riskLevel: 6,
            title: 'Test EQ',
            description: 'EQ Fund',
          }
        ]
      }
    },
    {
      title: this.language.menutitlebar17,
      icon: 'assets/images/icon/filter/icon-ssf@2x.png',
      activeIcon: 'assets/images/icon/filter/icon-ssf_@2x.png',
      content: {
        header: this.language.menutitlebar17,
        description: this.language.menudetailbar17,
        list: [
          {
            type: 'eq',
            riskLevel: 6,
            title: 'Test EQ',
            description: 'EQ Fund',
          }
        ]
      }
    },
    {
      title: this.language.menutitlebar18,
      icon: 'assets/images/icon/filter/icon-thaiesg@2x.png',
      activeIcon: 'assets/images/icon/filter/icon-thaiesg_@2x.png',
      content: {
        header: this.language.menutitlebar18,
        description: this.language.menudetailbar18,
        list: [
          {
            type: 'thai esg',
            riskLevel: 6,
            title: 'ThaiESG',
            description: 'ThaiEsg Fund',
          }
        ]
      }
    },
    {
      title: this.language.menutitlebar19,
      icon: 'assets/images/icon/filter/icon-ot@2x.png',
      activeIcon: 'assets/images/icon/filter/icon-ot_@2x.png',
      content: {
        header: this.language.menutitlebar19,
        description: this.language.menudetailbar19,
        list: [
          {
            type: 'other fund',
            riskLevel: 6,
            title: 'ThaiESG',
            description: 'ThaiEsg Fund',
          }
        ]
      }
    },
  ]

  constructor(private route: ActivatedRoute, private _riskService: FundriskService) {
    this.doughnutChartData = []
  }

  fundRisk: any;
  title: any;
  editRiskForm: any;
  riskDetail1_1: any;
  riskDetail1_1P: any;
  riskDetail1_2: any;
  riskDetail1_2P: any;
  riskLevelName: any;
  riskDetail2p: any;

  riskDetail3_1: any;
  riskDetail3_1P: any;
  riskDetail3_2: any;
  riskDetail3_2P: any;
  Image: any;

  p1: any;
  p2: any;
  p3: any;
  p4: any;
  p5: any;
  p6: any;

  donut: any
  doughnutChartData: any

  // chart data
  mmGraph: any
  fiGraph: any
  miGraph: any
  eqGraph: any
  propGraph: any
  gqeGraph: any

  fundList1: any;
  fundList2: any;
  fundList3: any;
  fundList4: any;
  fundList5: any;
  fundList6: any;

  totalPageCount: number
  currentPage: number = 1;
  recommendedFunds: any
  filterFundList: any

  selectedContent2: any

  totalPage: number

  onSelectRisk(riskLevel) {
    this.selectedType = 'risk'
    this.riskLevel = riskLevel
    this.selectedIndex = null
    this.doughnutChartData = []

    if (this.selectedType === 'risk' && riskLevel === 'low') {

      this._riskService.get_riskLevelByRiskID('1').subscribe(response => {
        this.fundRisk = response
        if (this.flag === 'th') {
          this.title = response[0]['title']

          this.riskDetail1_1 = response[0]['riskDetail1_1']
          this.riskDetail1_1P = response[0]['riskDetail1_1p']

          this.riskDetail1_2 = response[0]['riskDetail1_2']
          this.riskDetail1_2P = response[0]['riskDetail1_2p']

          this.riskDetail3_1 = response[0]['riskDetail3_1']
          this.riskDetail3_1P = response[0]['riskDetail3_1p']

          this.riskDetail3_2 = response[0]['riskDetail3_2']
          this.riskDetail3_2P = response[0]['riskDetail3_2p']
        } else {
          this.title = response[0]['title_en']

          this.riskDetail1_1 = response[0]['riskDetail1_1_en']
          this.riskDetail1_1P = response[0]['riskDetail1_1p']

          this.riskDetail1_2 = response[0]['riskDetail1_2_en']
          this.riskDetail1_2P = response[0]['riskDetail1_2p']

          this.riskDetail3_1 = response[0]['riskDetail3_1_en']
          this.riskDetail3_1P = response[0]['riskDetail3_1p']

          this.riskDetail3_2 = response[0]['riskDetail3_2_en']
          this.riskDetail3_2P = response[0]['riskDetail3_2p']
        }

        if (response[0]['riskLevelName'] === 'Low') {
          this.riskLevelName = this.language.allocation20
        } else if (response[0]['riskLevelName'] === 'Medium') {
          this.riskLevelName = this.language.allocation21
        } else {
          this.riskLevelName = this.language.allocation22
        }

        this.riskDetail2p = response[0]['riskDetail2p']

        this.Image = response[0]['Image']

        this.p1 = response[0]['p1']
        this.mmGraph = [this.language.graphtitle1 + '', parseInt(this.p1)]
        this.doughnutChartData.push(this.mmGraph)
        this.p2 = response[0]['p2']
        this.fiGraph = [this.language.graphtitle2 + '', parseInt(this.p2)]
        this.doughnutChartData.push(this.fiGraph)
        this.p3 = response[0]['p3']
        this.miGraph = [this.language.graphtitle3 + '', parseInt(this.p3)]
        this.doughnutChartData.push(this.miGraph)
        this.p4 = response[0]['p4']
        this.eqGraph = [this.language.graphtitle4 + '', parseInt(this.p4)]
        this.doughnutChartData.push(this.eqGraph)
        this.p5 = response[0]['p5']
        this.propGraph = [this.language.graphtitle5 + '', parseInt(this.p5)]
        this.doughnutChartData.push(this.propGraph)
        // this.p6 = response[0]['p6']
        // this.gqeGraph = ['กองทุนตราสารทุนต่างประเทศ', parseInt(this.p6)]
        // this.doughnutChartData.push(this.gqeGraph)
        this.donut = new Chart({
          chart: {
            renderTo: 'container',
            type: 'pie'
          },
          title: {
            text: null
          },
          yAxis: {
            title: {
              text: 'Total percent market share'
            }
          },
          plotOptions: {
            pie: {
              shadow: false,
              dataLabels: {
                enabled: false,
              },
              showInLegend: false,
              size: '80%'
            },
          },
          tooltip: {
            formatter: function () {
              return '<b>' + this.point.name + '</b>: ' + this.y + ' %';
            }
          },
          series: [{
            type: undefined,
            data: this.doughnutChartData,
            innerSize: '40%',
            showInLegend: false,
            dataLabels: {
              enabled: true,
              format: '{point.y} % <br/> {point.name}',
              style: {
                fontSize: '12px',
              },
              softConnector: 0,
              connectorShape: 'crookedLine'

            },
          }]
        });
      })


      this._riskService.getFundRiskMapp('1', '1').subscribe(response => {
        if (response[0]['FundNameEn'] !== '') {
          this.fundList1 = response
        }
        console.log('1', response);
      })

      this._riskService.getFundRiskMapp('2', '1').subscribe(response => {
        if (response[0]['FundNameEn'] !== '') {
          this.fundList2 = response
        }
        console.log('2', response);
      })

      this._riskService.getFundRiskMapp('3', '1').subscribe(response => {
        if (response[0]['FundNameEn'] !== '') {
          this.fundList3 = response
        }
        console.log('3', response);
      })

      this._riskService.getFundRiskMapp('4', '1').subscribe(response => {
        if (response[0]['FundNameEn'] !== '') {
          this.fundList4 = response
        }
        console.log('4', response);
      })

      this._riskService.getFundRiskMapp('5', '1').subscribe(response => {
        if (response[0]['FundNameEn'] !== '') {
          this.fundList5 = response
        }
        console.log('5', response);
      })

      // this._riskService.getFundRiskMapp("1", "7").subscribe(response => {
      //   this.fundList6 = response
      // })

    } else if (this.selectedType === 'risk' && riskLevel === 'med') {

      this._riskService.get_riskLevelByRiskID('2').subscribe(response => {

        this.fundRisk = response
        if (this.flag === 'th') {
        this.title = response[0]['title']

        this.riskDetail1_1 = response[0]['riskDetail1_1']
        this.riskDetail1_1P = response[0]['riskDetail1_1p']

        this.riskDetail1_2 = response[0]['riskDetail1_2']
        this.riskDetail1_2P = response[0]['riskDetail1_2p']

        this.riskDetail3_1 = response[0]['riskDetail3_1']
        this.riskDetail3_1P = response[0]['riskDetail3_1p']

        this.riskDetail3_2 = response[0]['riskDetail3_2']
        this.riskDetail3_2P = response[0]['riskDetail3_2p']
      } else {
        this.title = response[0]['title_en']

        this.riskDetail1_1 = response[0]['riskDetail1_1_en']
        this.riskDetail1_1P = response[0]['riskDetail1_1p']

        this.riskDetail1_2 = response[0]['riskDetail1_2_en']
        this.riskDetail1_2P = response[0]['riskDetail1_2p']

        this.riskDetail3_1 = response[0]['riskDetail3_1_en']
        this.riskDetail3_1P = response[0]['riskDetail3_1p']

        this.riskDetail3_2 = response[0]['riskDetail3_2_en']
        this.riskDetail3_2P = response[0]['riskDetail3_2p']

        }
        if (response[0]['riskLevelName'] === 'Low') {
          this.riskLevelName = this.language.allocation20
        } else if (response[0]['riskLevelName'] === 'Medium') {
          this.riskLevelName = this.language.allocation21
        } else {
          this.riskLevelName = this.language.allocation22
        }


        this.riskDetail2p = response[0]['riskDetail2p']

        this.Image = response[0]['Image']

        this.p1 = response[0]['p1']
        this.mmGraph = [this.language.fundriskdetailtitle4, parseInt(this.p1)]
        this.doughnutChartData.push(this.mmGraph)
        this.p2 = response[0]['p2']
        this.fiGraph = [this.language.fundriskdetailtitle5, parseInt(this.p2)]
        this.doughnutChartData.push(this.fiGraph)
        this.p3 = response[0]['p3']
        this.miGraph = [this.language.fundriskdetailtitle6, parseInt(this.p3)]
        this.doughnutChartData.push(this.miGraph)
        this.p4 = response[0]['p4']
        this.eqGraph = [this.language.fundriskdetailtitle7, parseInt(this.p4)]
        this.doughnutChartData.push(this.eqGraph)
        this.p5 = response[0]['p5']
        this.propGraph = [this.language.fundriskdetailtitle8, parseInt(this.p5)]
        this.doughnutChartData.push(this.propGraph)
        // this.p6 = response[0]['p6']
        // this.gqeGraph = ['กองทุนตราสารทุนต่างประเทศ', parseInt(this.p6)]
        // this.doughnutChartData.push(this.gqeGraph)
        this.donut = new Chart({
          chart: {
            renderTo: 'container',
            type: 'pie'
          },
          title: {
            text: null
          },
          yAxis: {
            title: {
              text: 'Total percent market share'
            }
          },
          plotOptions: {
            pie: {
              shadow: false,
              dataLabels: {
                enabled: false
              },
              showInLegend: false,
              size: '80%'
            },
          },
          tooltip: {
            formatter: function () {
              return '<b>' + this.point.name + '</b>: ' + this.y + ' %';
            }
          },
          series: [{
            type: undefined,
            data: this.doughnutChartData,
            innerSize: '40%',
            showInLegend: false,
            dataLabels: {
              enabled: true,
              format: '{point.y} % <br/> {point.name}',
              style: {
                fontSize: '12px',
              },
              softConnector: 0,
              connectorShape: 'crookedLine'
            },
          }]
        });
      })


      this._riskService.getFundRiskMapp('1', '2').subscribe(response => {
        if (response[0]['FundNameEn'] !== '') {
          this.fundList1 = response
        }
      })

      this._riskService.getFundRiskMapp('2', '2').subscribe(response => {
        if (response[0]['FundNameEn'] !== '') {
          this.fundList2 = response
        }
      })

      this._riskService.getFundRiskMapp('3', '2').subscribe(response => {

        if (response[0]['FundNameEn'] !== '') {

        }
      })

      this._riskService.getFundRiskMapp('4', '2').subscribe(response => {
        if (response[0]['FundNameEn'] !== '') {
          this.fundList4 = response
        }
      })

      this._riskService.getFundRiskMapp('5', '2').subscribe(response => {
        if (response[0]['FundNameEn'] !== '') {
          this.fundList5 = response
        }
      })

      // this._riskService.getFundRiskMapp("7", "2").subscribe(response => {
      //   this.fundList6 = response
      // })

    } else {

      this._riskService.get_riskLevelByRiskID('7').subscribe(response => {
        this.fundRisk = response
        if (this.flag === 'th') {
        this.title = response[0]['title']

        this.riskDetail1_1 = response[0]['riskDetail1_1']
        this.riskDetail1_1P = response[0]['riskDetail1_1p']

        this.riskDetail1_2 = response[0]['riskDetail1_2']
        this.riskDetail1_2P = response[0]['riskDetail1_2p']

        this.riskDetail3_1 = response[0]['riskDetail3_1']
        this.riskDetail3_1P = response[0]['riskDetail3_1p']

        this.riskDetail3_2 = response[0]['riskDetail3_2']
        this.riskDetail3_2P = response[0]['riskDetail3_2p']
      } else {
        this.title = response[0]['title_en']

        this.riskDetail1_1 = response[0]['riskDetail1_1_en']
        this.riskDetail1_1P = response[0]['riskDetail1_1p']

        this.riskDetail1_2 = response[0]['riskDetail1_2_en']
        this.riskDetail1_2P = response[0]['riskDetail1_2p']

        this.riskDetail3_1 = response[0]['riskDetail3_1_en']
        this.riskDetail3_1P = response[0]['riskDetail3_1p']

        this.riskDetail3_2 = response[0]['riskDetail3_2_en']
        this.riskDetail3_2P = response[0]['riskDetail3_2p']

        }
        if (response[0]['riskLevelName'] === 'Low') {
          this.riskLevelName = this.language.allocation20
        } else if (response[0]['riskLevelName'] === 'Medium') {
          this.riskLevelName = this.language.allocation21
        } else {
          this.riskLevelName = this.language.allocation22
        }

        this.riskDetail2p = response[0]['riskDetail2p']

        this.Image = response[0]['Image']

        this.p1 = response[0]['p1']
        this.mmGraph = [this.language.fundriskdetailtitle4, parseInt(this.p1)]
        this.doughnutChartData.push(this.mmGraph)
        this.p2 = response[0]['p2']
        this.fiGraph = [this.language.fundriskdetailtitle5, parseInt(this.p2)]
        this.doughnutChartData.push(this.fiGraph)
        this.p3 = response[0]['p3']
        this.miGraph = [this.language.fundriskdetailtitle6, parseInt(this.p3)]
        this.doughnutChartData.push(this.miGraph)
        this.p4 = response[0]['p4']
        this.eqGraph = [this.language.fundriskdetailtitle7, parseInt(this.p4)]
        this.doughnutChartData.push(this.eqGraph)
        this.p5 = response[0]['p5']
        this.propGraph = [this.language.fundriskdetailtitle8, parseInt(this.p5)]
        this.doughnutChartData.push(this.propGraph)
        // this.p6 = response[0]['p6']
        // this.gqeGraph = ['กองทุนตราสารทุนต่างประเทศ', parseInt(this.p6)]
        // this.doughnutChartData.push(this.gqeGraph)
        this.donut = new Chart({
          chart: {
            renderTo: 'container',
            type: 'pie'
          },
          title: {
            text: null
          },
          yAxis: {
            title: {
              text: 'Total percent market share'
            }
          },
          plotOptions: {
            pie: {
              shadow: false,
              dataLabels: {
                enabled: false
              },
              showInLegend: false,
              size: '80%'
            },
          },
          tooltip: {
            formatter: function () {
              return '<b>' + this.point.name + '</b>: ' + this.y + ' %';
            }
          },
          series: [{
            type: undefined,
            data: this.doughnutChartData,
            innerSize: '40%',
            showInLegend: false,
            dataLabels: {
              enabled: true,
              format: '{point.y} % <br/> {point.name}',
              style: {
                fontSize: '12px',
              },
              softConnector: 0,
              connectorShape: 'crookedLine'
            },
          }]
        });

      })

      this._riskService.getFundRiskMapp('1', '7').subscribe(response => {
        if (response[0]['FundNameEn'] !== '') {
          this.fundList1 = response
        }
      })

      this._riskService.getFundRiskMapp('2', '7').subscribe(response => {


        if (response[0]['FundNameEn'] !== '') {
          this.fundList2 = response
        }
      })

      this._riskService.getFundRiskMapp('3', '7').subscribe(response => {

        if (response[0]['FundNameEn'] !== '') {
          this.fundList3 = response
        }
      })

      this._riskService.getFundRiskMapp('4', '7').subscribe(response => {
        if (response[0]['FundNameEn'] !== '') {
          this.fundList4 = response
        }
      })

      this._riskService.getFundRiskMapp('5', '7').subscribe(response => {
        if (response[0]['FundNameEn'] !== '') {
          this.fundList5 = response
        }
      })

      // this._riskService.getFundRiskMapp("7", "7").subscribe(response => {
      //   this.fundList6 = response
      // })
    }

  }

  onSelectedContent(content, index) {
    this.currentPage = 1;
    this.riskLevel = null
    this.selectedType = 'filter'
    this.selectedIndex = index
    this.selectedContent = content


    if (index === 0) {
      this._riskService.getTopFund().subscribe(response => {
        this.selectedContent2 = response
        this.totalPage = this.setTotalPage(this.selectedContent2)
        this.renderListPerPage(this.selectedContent2)
      })
    } else if (index === 1) {
      this._riskService.getFundByType('16').subscribe(response => {
        this.selectedContent2 = response
        this.totalPage = this.setTotalPage(this.selectedContent2)
        this.renderListPerPage(this.selectedContent2)
      })
    } else if (index === 2) {
      this._riskService.getFundByType('1').subscribe(response => {
        this.selectedContent2 = response
        this.totalPage = this.setTotalPage(this.selectedContent2)
        this.renderListPerPage(this.selectedContent2)
      })
    } else if (index === 3) {
      this._riskService.getFundByType('2').subscribe(response => {
        this.selectedContent2 = response
        this.totalPage = this.setTotalPage(this.selectedContent2)
        this.renderListPerPage(this.selectedContent2)
      })
    } else if (index === 4) {
      this._riskService.getFundByType('3').subscribe(response => {
        this.selectedContent2 = response
        this.totalPage = this.setTotalPage(this.selectedContent2)
        this.renderListPerPage(this.selectedContent2)
      })
    } else if (index === 5) {
      this._riskService.getFundByType('12').subscribe(response => {
        this.selectedContent2 = response
        console.log(response)
        this.totalPage = this.setTotalPage(this.selectedContent2)
        this.renderListPerPage(this.selectedContent2)
      })
    } else if (index === 6) {
      this._riskService.getFundByType('4').subscribe(response => {
        this.selectedContent2 = response
        this.totalPage = this.setTotalPage(this.selectedContent2)
        this.renderListPerPage(this.selectedContent2)
      })
    } else if (index === 7) {
      this._riskService.getFundByType('7').subscribe(response => {
        this.selectedContent2 = response
        this.totalPage = this.setTotalPage(this.selectedContent2)
        this.renderListPerPage(this.selectedContent2)
      })
    } else if (index === 8) {
      this._riskService.getFundByType('5').subscribe(response => {
        this.selectedContent2 = response
        this.totalPage = this.setTotalPage(this.selectedContent2)
        this.renderListPerPage(this.selectedContent2)
      })
    } else if (index === 9) {
      this._riskService.getFundByType('6').subscribe(response => {
        this.selectedContent2 = response
        this.totalPage = this.setTotalPage(this.selectedContent2)
        this.renderListPerPage(this.selectedContent2)
      })
    } else if (index === 10) {
      this._riskService.getFundByType('11').subscribe(response => {
        this.selectedContent2 = response
        this.totalPage = this.setTotalPage(this.selectedContent2)
        this.renderListPerPage(this.selectedContent2)
      })
    } else if (index === 11) {
      this._riskService.getFundByType('9').subscribe(response => {
        this.selectedContent2 = response
        this.totalPage = this.setTotalPage(this.selectedContent2)
        this.renderListPerPage(this.selectedContent2)
      })
    } else if (index === 12) {
      this._riskService.getFundByType('10').subscribe(response => {
        this.selectedContent2 = response
        this.totalPage = this.setTotalPage(this.selectedContent2)
        this.renderListPerPage(this.selectedContent2)
      })
    } else if (index === 13) {
      this._riskService.getFundByType('13').subscribe(response => {
        this.selectedContent2 = response
        this.totalPage = this.setTotalPage(this.selectedContent2)
        this.renderListPerPage(this.selectedContent2)
      })
    } else if (index === 14) {
      this._riskService.getFundByType('8').subscribe(response => {
        this.selectedContent2 = response
        this.totalPage = this.setTotalPage(this.selectedContent2)
        this.renderListPerPage(this.selectedContent2)
      })
    } else if (index === 15) {
      this._riskService.getFundByType('14').subscribe(response => {
        this.selectedContent2 = response
        this.totalPage = this.setTotalPage(this.selectedContent2)
        this.renderListPerPage(this.selectedContent2)
      })
    } else if (index === 16) {
      this._riskService.getFundByType('15').subscribe(response => {
        this.selectedContent2 = response
        this.totalPage = this.setTotalPage(this.selectedContent2)
        this.renderListPerPage(this.selectedContent2)
      })
    } else if (index === 17) {
      this._riskService.getFundByType('17').subscribe(response => {
        this.selectedContent2 = response
        this.totalPage = this.setTotalPage(this.selectedContent2)
        this.renderListPerPage(this.selectedContent2)
      })
    }else if (index === 18) {
      this._riskService.getFundByType('18').subscribe(response => {
        this.selectedContent2 = response
        // this.selectedContent2.forEach(item => {
        //   item['type'] = "thaiesg"
        // });
        this.totalPage = this.setTotalPage(this.selectedContent2)
        
        this.renderListPerPage(this.selectedContent2)
      })
    }else if (index === 19) {
      this._riskService.getFundByType('20').subscribe(response => {
        this.selectedContent2 = response
        // this.selectedContent2.forEach(item => {
        //   item['type'] = "thaiesg"
        // });
        this.totalPage = this.setTotalPage(this.selectedContent2)
        
        this.renderListPerPage(this.selectedContent2)
      })
    }
  }

  ngOnInit() {

    this.flag = localStorage.getItem('language_flag')

    this.getPostdata();

    this.selectedContent = this.sectionList[0].content

    this.navigateTo = this.route.params.subscribe(params => {

      this.selectedType = sessionStorage.getItem('Fund')

      if (this.selectedType === 'risk') {
        this.riskLevel = 'low'
        this.selectedIndex = null
        this.selectedType = 'risk'
        this._riskService.get_riskLevelByRiskID('1').subscribe(response => {

          this.fundRisk = response
          if (this.flag === 'th') {
          this.title = response[0]['title']

          this.riskDetail1_1 = response[0]['riskDetail1_1']
          this.riskDetail1_1P = response[0]['riskDetail1_1p']

          this.riskDetail1_2 = response[0]['riskDetail1_2']
          this.riskDetail1_2P = response[0]['riskDetail1_2p']

          this.riskDetail3_1 = response[0]['riskDetail3_1']
          this.riskDetail3_1P = response[0]['riskDetail3_1p']

          this.riskDetail3_2 = response[0]['riskDetail3_2']
          this.riskDetail3_2P = response[0]['riskDetail3_2p']
        } else {
          this.title = response[0]['title_en']

          this.riskDetail1_1 = response[0]['riskDetail1_1_en']
          this.riskDetail1_1P = response[0]['riskDetail1_1p']

          this.riskDetail1_2 = response[0]['riskDetail1_2_en']
          this.riskDetail1_2P = response[0]['riskDetail1_2p']

          this.riskDetail3_1 = response[0]['riskDetail3_1_en']
          this.riskDetail3_1P = response[0]['riskDetail3_1p']

          this.riskDetail3_2 = response[0]['riskDetail3_2_en']
          this.riskDetail3_2P = response[0]['riskDetail3_2p']

          }
          if (response[0]['riskLevelName'] === 'Low') {
            this.riskLevelName = this.language.allocation20
          } else if (response[0]['riskLevelName'] === 'Medium') {
            this.riskLevelName = this.language.allocation20
          } else {
            this.riskLevelName = this.language.allocation22
          }

          this.riskDetail2p = response[0]['riskDetail2p']

          this.Image = response[0]['Image']

          this.p1 = response[0]['p1']
          this.mmGraph = [this.language.fundriskdetailtitle4, parseInt(this.p1)]
          this.doughnutChartData.push(this.mmGraph)
          this.p2 = response[0]['p2']
          this.fiGraph = [this.language.fundriskdetailtitle5, parseInt(this.p2)]
          this.doughnutChartData.push(this.fiGraph)
          this.p3 = response[0]['p3']
          this.miGraph = [this.language.fundriskdetailtitle6, parseInt(this.p3)]
          this.doughnutChartData.push(this.miGraph)
          this.p4 = response[0]['p4']
          this.eqGraph = [this.language.fundriskdetailtitle7, parseInt(this.p4)]
          this.doughnutChartData.push(this.eqGraph)
          this.p5 = response[0]['p5']
          this.propGraph = [this.language.fundriskdetailtitle8, parseInt(this.p5)]
          this.doughnutChartData.push(this.propGraph)
          // this.p6 = response[0]['p6']
          // this.gqeGraph = ['กองทุนตราสารทุนต่างประเทศ', parseInt(this.p6)]
          // this.doughnutChartData.push(this.gqeGraph)

          this.donut = new Chart({
            chart: {
              renderTo: 'container',
              type: 'pie'
            },
            title: {
              text: null
            },
            yAxis: {
              title: {
                text: 'Total percent market share'
              }
            },
            plotOptions: {
              pie: {
                shadow: false,
                dataLabels: {
                  enabled: false
                },
                showInLegend: false,
                size: '80%'
              },
            },
            tooltip: {
              formatter: function () {
                return '<b>' + this.point.name + '</b>: ' + this.y + ' %';
              }
            },
            series: [{
              type: undefined,
              data: this.doughnutChartData,
              innerSize: '40%',
              showInLegend: false,
              dataLabels: {
                enabled: true,
                format: '{point.y} % <br/> {point.name}',
                style: {
                  fontSize: '12px',
                },
                softConnector: 0,
                connectorShape: 'crookedLine'
              },
            }]
          });
        })

        this._riskService.getFundRiskMapp('1', '1').subscribe(response => {
          if (response[0]['FundNameEn'] !== '') {
            this.fundList1 = response
          }
        })

        this._riskService.getFundRiskMapp('2', '1').subscribe(response => {
          if (response[0]['FundNameEn'] !== '') {
            this.fundList2 = response
          }
        })

        this._riskService.getFundRiskMapp('3', '1').subscribe(response => {
          if (response[0]['FundNameEn'] !== '') {
            this.fundList3 = response
          }
        })

        this._riskService.getFundRiskMapp('4', '1').subscribe(response => {
          if (response[0]['FundNameEn'] !== '') {
            this.fundList4 = response
          }
        })

        this._riskService.getFundRiskMapp('5', '1').subscribe(response => {
          if (response[0]['FundNameEn'] !== '') {
            this.fundList5 = response
          }
        })

        // this._riskService.getFundRiskMapp("1", "7").subscribe(response => {
        //   this.fundList6 = response
        // })
      } else if (this.selectedType === 'filter') {
        this.riskLevel = null
        this.selectedType = 'filter'
        this.selectedIndex = 0
        this.selectedContent = 1

        this._riskService.getTopFund_all().subscribe(response => {
          this.selectedContent2 = response
          this.totalPage = this.setTotalPage(this.selectedContent2)
          this.renderListPerPage(this.selectedContent2)
        })
      } else if (this.selectedType === 'recommend') {

        this.riskLevel = null
        // this.selectedType = params['type']
        // this.selectedIndex = 0
        // this.selectedContent = 1

        this._riskService.getTopFund().subscribe(response => {
          this.selectedContent2 = response
          this.totalPage = this.setTotalPage(this.selectedContent2)
          this.renderListPerPage(this.selectedContent2)
        })
      } else if (this.selectedType == null) {

        this.riskLevel = null
        this.selectedType = 'recommend'
        this.selectedIndex = 0
        this.selectedContent = 1

        this._riskService.getTopFund_all().subscribe(response => {
          this.selectedContent2 = response
          this.totalPage = this.setTotalPage(this.selectedContent2)
          this.renderListPerPage(this.selectedContent2)
        })
      }
    })
  }

  setTotalPage(objectFundType) {
    if (Object.keys(objectFundType).length <= 12) {
      return 1
    } else {
      return Math.ceil(Object.keys(objectFundType).length / 12)
    }
  }

  pageChange(event) {
    this.currentPage = event
    this.renderListPerPage(this.selectedContent2)
  }

  renderListPerPage(fundList) {
    if (fundList !== undefined) {
      this.filterFundList = fundList.slice(this.currentPage * 12 - 12, this.currentPage * 12)
    }
  }

  setMenu(clickMenu) {
    sessionStorage.setItem('clickMenu', clickMenu)
  }

  getPostdata() {

    this._riskService.GetAssumption().subscribe(response => {
      // this.footerrisk = response
      this.footerrisk = response['Result']
    })
  }
}